export default function About() {
  return (
    <section id="about" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-4">
            平台介绍
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            关于桃子影院
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            桃子影院致力于为全球华语观众打造一站式高清影视平台
          </p>
        </div>

        <div className="bg-background-200/60 rounded-2xl border border-background-300/30 p-8 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            <div className="flex-1">
              <h3 className="font-heading text-xl font-semibold text-foreground-100 mb-4">
                您的私人影院，随时随地畅享高清世界
              </h3>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                桃子影院是一个专注于高清影视内容聚合与分发的在线平台，涵盖电影、电视剧、综艺、动漫、纪录片等丰富品类。
                我们与多家正版内容提供商合作，确保资源稳定可靠，画质从标清到4K蓝光全覆盖。
              </p>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                平台采用先进的P2P-CDN混合加速技术，无论您身处何地，都能享受不缓冲、秒开播放的流畅体验。
                每日凌晨自动更新最新剧集与电影，追剧不再等待。
              </p>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
                桃子影院坚持永久免费策略，不设会员门槛，所有内容面向全体用户开放。我们相信，好的影视作品应该被更多人看到。
              </p>
            </div>
            <div className="lg:w-[280px] flex-shrink-0">
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-background-50 rounded-xl p-4 text-center border border-background-300/20">
                  <div className="w-9 h-9 mx-auto mb-2 rounded-lg bg-primary-500/10 flex items-center justify-center">
                    <i className="ri-movie-line text-primary-400 text-lg"></i>
                  </div>
                  <div className="text-lg font-bold text-foreground-100">10万+</div>
                  <div className="text-xs text-foreground-500">影视资源</div>
                </div>
                <div className="bg-background-50 rounded-xl p-4 text-center border border-background-300/20">
                  <div className="w-9 h-9 mx-auto mb-2 rounded-lg bg-accent-500/10 flex items-center justify-center">
                    <i className="ri-4k-line text-accent-400 text-lg"></i>
                  </div>
                  <div className="text-lg font-bold text-foreground-100">4K</div>
                  <div className="text-xs text-foreground-500">蓝光画质</div>
                </div>
                <div className="bg-background-50 rounded-xl p-4 text-center border border-background-300/20">
                  <div className="w-9 h-9 mx-auto mb-2 rounded-lg bg-secondary-500/10 flex items-center justify-center">
                    <i className="ri-flashlight-line text-secondary-400 text-lg"></i>
                  </div>
                  <div className="text-lg font-bold text-foreground-100">秒开</div>
                  <div className="text-xs text-foreground-500">无需缓冲</div>
                </div>
                <div className="bg-background-50 rounded-xl p-4 text-center border border-background-300/20">
                  <div className="w-9 h-9 mx-auto mb-2 rounded-lg bg-primary-500/10 flex items-center justify-center">
                    <i className="ri-user-smile-line text-primary-400 text-lg"></i>
                  </div>
                  <div className="text-lg font-bold text-foreground-100">永久</div>
                  <div className="text-xs text-foreground-500">免费观看</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}